@import 'src/global/media_queries'

:host
  display: block
  width: 100%

footer
  width: 100%
  height: fit-content
  padding: 1rem

  @include media(">=tablet")
    padding: 1.5rem 2rem

  .footer-container
    width: 100%
    display: grid
    grid-template-columns: 1fr
    grid-template-areas: 'social' 'links' 'payment' 'ascend'
    gap: 1rem 0

    @include media('>=tablet')
      grid-template-columns: 2fr 3fr
      grid-template-areas: 'social payment' 'links ascend'
      gap: 0.5rem 0

    & > *
      text-align: center
      padding: 0.5rem 0

      &.social ul,
      &.payment ul
        padding-top: 0.5rem

      & > span
        font-size: var(--fs-l)
        font-weight: 700

      @include media('>=tablet')
        &.social,
        &.links
          text-align: left

        &.payment,
        &.ascend
          text-align: right

        & > span
          font-size: var(--fs-m)

    ul
      padding: 0
      margin: 0
      list-style: none
      display: flex

    .social
      grid-area: social

      ul
        flex-wrap: wrap
        justify-content: center

        @include media(">=tablet")
          justify-content: flex-start

        li
          width: 3rem
          padding: 0.5rem
          display: flex
          justify-content: center
          align-items: center

          afs-asset
            width: fit-content
            height: 100%

    .payment
      grid-area: payment

      ul
        flex-wrap: wrap
        justify-content: center
        align-items: center
        
        @include media(">=tablet")
          justify-content: flex-end

        li
          width: 4.5rem
          max-height: 5rem
          padding: 0.5rem
          display: flex
          justify-content: center
          align-items: center

        //   &.payment-large
        //       max-height: 5rem

          afs-asset
            width: 100%
            height: 100%

    .links
      grid-area: links

      @include media(">=tablet")
        display: flex
        justify-content: flex-start
        align-items: center

      ul
        flex-direction: column
        align-items: center
        font-weight: 700
        font-size: var(--fs-m)

        li
          padding: 0

          a
            font-weight: 500

        @include media(">=tablet")
          align-items: flex-start
          font-size: var(--fs-s)

    .ascend
      grid-area: ascend
      display: grid
      grid-template-columns: 1fr 1fr
      grid-template-areas: 'logo raised' 'copyright copyright'
      gap: 1rem 1rem
      font-family: var(--ff-pragati)

      @include media('>=tablet')
        grid-template-columns: 1fr
        grid-template-areas: 'logo' 'raised' 'copyright'
        gap: 0rem
        br
          display: none

      .ascend-logo
        display: -ms-grid
        display: grid
        width: 85%
        max-width: 10rem
        justify-self: flex-end
        align-self: center
        grid-area: logo

      .ascend-raised
        grid-area: raised
        display: flex
        flex-direction: column
        justify-content: center
        align-items: flex-start
        text-align: left
        font-size: calc(0.6rem + var(--fs-multiplier))
        text-transform: uppercase
        letter-spacing: 0.2rem

        @include media('>=tablet')
          text-align: right
          align-items: flex-end
          font-size: var(--fs-s)
          letter-spacing: var(--ls-normal) !important
          font-weight: 400
          text-transform: none

      .ascend-copyright
        grid-area: copyright
        font-size: var(--fs-s)
        text-transform: uppercase

        a
          text-decoration: underline

        @include media(">=tablet")
          display: flex
          justify-content: flex-end
          align-items: center
          font-size: var(--fs-xs)

          a
            padding: 0 0.2rem

#custom-footer
  background-color: var(--fc)
  color: var(--ffc)
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
  padding: 1.5rem 2rem

  .flex-container
    display: flex
    flex-direction: row
    justify-content: center
    align-items: center

  a
    display: inline-block
    text-decoration: none
    transition: all 0.1s linear 0s

  .logo-container
    margin-right: 15px

  .ascend-raised
    text-transform: uppercase
    letter-spacing: 0.2rem
    margin-left: 15px
    font-weight: 700
    font-size: var(--fs-s)
    font-family: var(--ff-pragati)

  .ascend-copyright
    text-align: center
    font-size: 12.5px
    text-transform: uppercase
    font-family: var(--ff-pragati)

  .ascend-copyright a
    font: inherit
    color: var(--ffc)
    text-decoration: underline

  @include media('>=tablet')
    .flex-container
      flex-direction: column

    .logo-container
      margin-right: 0

    .ascend-raised
      letter-spacing: normal
      text-transform: none
      margin-left: 0
      font-weight: 400

    .ascend-copyright
      font-size: 11px

    br
      display: none
